<template>

    <span class="alarmeTaskResult">

        <span class="alarmeTaskResult" v-if="chartdata">

           <line-chart
                   v-if="loaded"
                   v-on:set-chart="setChart"
                   :chartdata="chartdata"
                   :options="options" />

          <!-- Legende -->
          <ul v-bind:style="{ listStyleImage: 'url(' + listImageBlau + ')', marginBottom: 0 }" class="mt-2 ml-4">
            <li style="font-size: 0.9rem">{{ $t('message.charts_nicht_pruefbar') }}</li>
          </ul>
          <ul v-bind:style="{ listStyleImage: 'url(' + listImageGruen + ')', marginBottom: 0 }" class="ml-4">
            <li style="font-size: 0.9rem">{{ $t('message.default_ok') }}</li>
          </ul>
          <ul v-bind:style="{ listStyleImage: 'url(' + listImageGelb + ')', marginBottom: 0 }" class="ml-4">
            <li style="font-size: 0.9rem">{{ $t('message.charts_warnung') }}</li>
          </ul>
          <ul v-bind:style="{ listStyleImage: 'url(' + listImageRot + ')' }" class="ml-4">
            <li style="font-size: 0.9rem">{{ $t('message.charts_gefahr') }}</li>
          </ul>

        </span>
        <div v-else-if="!chartdata && !loaded" class="text-center">
            <SpinnerImage/>
        </div>
        <b-alert show v-if="setNoData">{{ $t('message.charts_nicht_genuegend_ergebnisse') }}</b-alert>

        <!-- Ergebnisliste bei Klick auf Icon -->
        <b-modal :id="'modal-ergebnisse-' + taskErgebnisId"
                 title="Ergebnisliste"
                 hide-footer
                 size="lg"
                 class="modal-ergebnisse">
          <monatsbericht-ergebnisse v-model="ergebnisliste"
                                    :is-plan-ansicht="isPlanAnsicht"
                                    :hide-headers="true"
          />
        </b-modal>

    </span>

</template>

<script>

    import axios from 'axios';
    axios.defaults.withCredentials = true;
    import LineChart from '@/components/charts/LineChart';
    import SpinnerImage from "@/components/layout/SpinnerImage";
    import MonatsberichtErgebnisse from "@/components/ergebnisliste/MonatsberichtErgebnisse";

    export default {
      name: 'LineStackedAreaChartAlarmeTaskResult',
      components: {
        LineChart,
        SpinnerImage,
        MonatsberichtErgebnisse
      },
      props: ['taskErgebnisId', 'isPlanAnsicht'],
      data () {
        return {
          /** noch kein Ergebnis verfügbar - true setzen */
          setNoData: false,
          loaded: false,
          /** Daten für den Bar Chart */
          chartdata: null,
          options: null,
          /** Chart.js Chart */
          chart: null,
          areasAllowed: null,
          /** Ergebnisliste auf Klick auf den Icon */
          ergebnisliste: null,
          listImageGruen: require('@/assets/images/list-style-plan-gruen.gif'),
          listImageGelb:  require('@/assets/images/list-style-plan-gelb.gif'),
          listImageRot:   require('@/assets/images/list-style-plan-rot.gif'),
          listImageBlau:  require('@/assets/images/list-style-plan-blau.gif')
        }
      },
      watch: {
        taskErgebnisId: function () {
            this.init();
        }
      },
      created () {

        this.init();

      },
      methods: {

        init: async function () {

          this.loaded = false;
          if (this.taskErgebnisId) {

            // ich brauche hier die Areas von allen Standorten des Benutzers:
            this.areasAllowed = null;
            if (this.$store.getters.showAreas && this.$store.getters.showAreas.length > 0) {
              this.areasAllowed = this.$store.getters.showAreas.join(',');
            }

            var url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getChartDataOfBesuchsbericht';
            var params  = {
              task_ergebnis_id: this.taskErgebnisId,
              type:             'LINE_STACKED_AREA_CHART_TASK_ERGEBNIS',
              areasAllowed:     this.areasAllowed
            };

            var that = this;
            await axios({
              method: 'GET',
              params: params,
              url: url
            }).then(function (response) {

              if (response.data) {

                that.chartdata = response.data.chartdata;
                if (that.chartdata) {

                  var datasets = that.chartdata.datasets;
                  if (datasets) {
                    // Chart.js 4: tension wieder auf 0.4 (Default war 0.4 in 2.x,
                    // jetzt 0). Kein fill - Position-Details-Chart zeigt nur die
                    // Linie mit Punkten.
                    datasets.forEach(ds => {
                      ds.tension = 0.4
                      ds.borderWidth = 1
                    })

                    var hasTicks = Object.keys(that.chartdata.ticks).length > 0;
                    // kalkuliere max y Wert, falls Required Text:
                    var max = 0;
                    if (that.chartdata.ticks && hasTicks) {
                      for (const [key, value] of Object.entries(that.chartdata.ticks)) {
                        console.log(key, value);
                        if (key > max) max = key;
                      }
                    }
                    console.log('max WERT: ' + max);

                    var yScale = {
                      display: true,
                      title: {
                        display: true,
                        text: that.$t('message.printErgebnisliste_ergebnis')
                      },
                    };
                    var tooltip = null;
                    if (hasTicks) {

                      console.log('chart hat ticks: ' + Object.keys(that.chartdata.ticks).length + ' hasTicks ' + hasTicks);
                      yScale.beginAtZero = true;
                      yScale.min = 0;
                      yScale.max = max;
                      yScale.ticks = {
                        callback: function (value, index) {
                          if (that.chartdata && that.chartdata.ticks) {
                            let ticksdata = that.chartdata.ticks[value];
                            if (ticksdata) {
                              console.log('get from ticks ' + that.chartdata.ticks[value] + ' index: ' + index);
                              return ticksdata;
                            }
                          }
                          console.log("get value = " + value + " " + that.chartdata.ticks);
                          if (that.chartdata && that.chartdata.ticks[1]) {
                            return '';
                          }
                          if (that.chartdata && typeof that.chartdata.datasets[0].data[0] === 'number') {
                            return value;
                          }
                          return '';
                        }
                      };

                    } else {
                      yScale.beginAtZero = true;
                      yScale.min = 0;
                    }

                    // nicht überprüfbar kommt als 0 (Farbe NICHT_PRUEFBAR), im Tooltip als Text anzeigen
                    tooltip = {
                      callbacks: {
                        label: function (ctx) {
                          var label = ctx.dataset.label;
                          if (!label) label = '';
                          let wert;
                          if (ctx.dataset.notCheckable && ctx.dataset.notCheckable[ctx.dataIndex]) {
                            wert = that.$t('message.charts_nicht_pruefbar');
                          } else if (that.chartdata.ticks) {
                            wert = that.chartdata.ticks[ctx.parsed.y];
                          }
                          if (!wert) {
                            wert = ctx.formattedValue;
                          }
                          label += ": " + wert;
                          return label;
                        }
                      }
                    };

                    that.options =
                        {
                          responsive: true,
                          onClick: that.chartClickEvent,
                          hover: {
                            mode: 'index'
                          },
                          plugins: {
                            title: {
                              display: false
                            },
                            legend: {
                              display: false
                            }
                          },
                          scales: {
                            x: {
                              display: true,
                              title: {
                                display: false
                              }
                            },
                            y: yScale
                          }
                        };

                    if (tooltip) {
                      that.options.plugins.tooltip = tooltip;
                    }

                  } else {
                    that.chartdata = null;
                    that.setNoData = true;
                    that.$emit('no-data', true);
                  }

                } else { // end if that.chartdata
                  that.setNoData = true;
                  that.$emit('no-data', true);
                }

              }
              that.loaded = true;

            }).catch(error => {
              console.log(error);
              that.loaded = true;
              that.setNoData = true;
              that.$emit('no-data', true);
            });
          }

        },
        /**
         * Chart des Parents zurückliefern um Klick Events zu behandeln
         */
        setChart: function (obj) {
          console.log('set chart: ', obj);
          this.chart = obj;
        },
        /**
         * Klick auf den Chart, Filter setzen
         * @param event click Event
         */
        chartClickEvent: function (event) {

          console.log('chartClickEvent ' + event);
          var elements = this.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);
          if (elements && elements.length > 0) {
            console.log('index = ' + elements[0].index);
            var index = elements[0].index;
            var label = this.chart.config.data.labels[index];
            console.log('label = ' + label);
            if (label) {

              // hole die Ergebnisse zu diesem Punkt vom Datenbroker
              // datasetIndex 0 = ROT, datasetIndex 1 = GELB
              this.getErgebnisse(index);

            }
          }

        },
        /**
         * holt die Ergebnisse dieses Tasks, index = der Besuchsbericht in der Liste der Besuchsberichte für diesen Task
         */
        getErgebnisse: function (index) {

          console.log('getErgebnisse für index = ' + index);

          this.showSpinner();
          this.ergebnisliste = null;
          var url            = process.env.VUE_APP_SERVER_URL + '/datenbroker/getChartDataErgebnisse';
          var params         = {
            task_ergebnis_id:     this.taskErgebnisId,
            areasAllowed:         this.areasAllowed,
            index:                index
          };

          var that = this;
          axios({
            method: 'GET',
            params: params,
            url: url
          }).then(function (response) {

            that.ergebnisliste = response.data;
            that.hideSpinner();
            if (that.ergebnisliste && that.ergebnisliste.length > 0) {
              that.$bvModal.show('modal-ergebnisse-' + that.taskErgebnisId);
            }

          });

        }

      }

    }

</script>

<style scoped>
  .modal-ergebnisse .modal-lg {
      max-width: 1250px;
  }
</style>